<template>
  <v-list
    class="module-list nx-primary--lighten-5"
    two-line>
    <v-subheader
      class="text-uppercase"
      v-if="group.group"
      :style="{ 'margin-left': `${16 * group.depth}px` }">
      <b>
        {{
          !group.depth
            ? $t(`message.board.type.${boardType}`)
            : $t(`message.composition.moduleList.${group.group}`)
        }}
      </b>
    </v-subheader>
    <v-list-tile
      v-for="module in modules"
      ripple
      avatar
      :key="module.type"
      @click="$emit('click:module', module.type)">
      <v-list-tile-avatar
        tile
        size="70"
        class="mr-2">
        <img
          :src="module.thumbnail"
          :alt="translate(module.name)"
          @error="$emit('load:img-error', $event)">
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title v-html="translate(module.name)"></v-list-tile-title>
      </v-list-tile-content>
      <v-list-tile-action>
        <v-icon>chevron_right</v-icon>
      </v-list-tile-action>
    </v-list-tile>

    <nx-composition-module-list
      v-if="group && group.subgroups"
      v-for="(sub, index) in group.subgroups"
      :key="index"
      :group="sub"
      :modules="sub.modules"
      v-on="$listeners"
    ></nx-composition-module-list>
  </v-list>
</template>

<script>
import { translateCandidates } from '@/utils';

export default {
  name: 'nx-composition-module-list',
  props: {
    boardType: {
      type: String,
      default: null,
    },
    group: {
      type: Object,
      default: () => ({}),
    },
    modules: Array,
  },
  methods: {
    translate(translatable, translationVars = []) {
      return translateCandidates(
        [
          `message.${translatable}`,
          translatable,
        ],
        translatable,
        translationVars,
      );
    },
  },
};
</script>
